





















































import { Component, Vue } from 'vue-property-decorator';
import draggable from 'vuedraggable';

@Component({
    components: {
        draggable,
    },
})
export default class Ballot extends Vue {
    private ranked:
        { ID: string; Name: string; Dropped: boolean}[] = [];
    private unranked: { ID: string; Name: string; Dropped: boolean }[] = [];
    private alertText = '';
    private alreadyVoted = false;

    private get canSubmit(): boolean {
        return this.ranked.length > 0;
    }
    
    mounted() {
        Promise.all(
            [
                this.updateCandidates(),
                this.updateBallot()
            ]
        ).then(results => {
            const ballot = results[1];
            if (ballot.CandidateIDs && ballot.CandidateIDs.length) {
                this.ranked = [];
                // Get a map of candidates
                const candidateMap = new Map(this.unranked.map(c => [c.ID, c]));

                for (const id of ballot.CandidateIDs) {
                    const candidate = candidateMap.get(id);
                    if (candidate) {
                        this.ranked.push(candidate);
                    }
                }
                this.unranked = this.unranked.filter( c => !ballot.CandidateIDs.includes(c.ID) );
            }

        });
    }

    async updateCandidates() {
        try {
            const response = await this.$http.get(
                '/election/candidate'
            );
            this.unranked = response.data;
            this.ranked = [];
        } catch (err) {
            this.alertText = err.response.data;
        }
    }

    async updateBallot() {
        try {
            const response = await this.$http.get(
                '/election/ballot'
            );
            const ballot = response.data;
            if (ballot.CandidateIDs.length != 0) {
                this.alreadyVoted = true;
            }
            return ballot;
        } catch (err) {
            console.log("Error getting old ballot", err.response);
            return {};
        }
    }

    async submitBallot() {
        try {
            const CandidateIDs = this.ranked.map(
                candidate => candidate.ID
            )
            await this.$http.post(
                'election/ballot',
                {
                    CandidateIDs
                }
            )
            this.alertText = 'Thank you for participating!';
        } catch (err) {
            this.alertText = err.response.data;
        }
    }

}
